import useSWR from 'swr';
import { REFRESH_INTERVAL_MINE_RECENT_TICKETS } from '../constants/swr-config';
import { customSWRConfig, customSWRResponse, status } from '../model/types';
import useSWRCacheKeys from './useSWRCacheKeys';

export interface RecentTicket {
    requester: string;
    status: status;
    subject: string;
    ticketKey: string;
    email: string;
}
export default function useRecentTickets<T extends RecentTicket[]>(config: customSWRConfig = {}): customSWRResponse<T> {
    const keys = useSWRCacheKeys('/tickets/mine-recent');

    return useSWR<T>(keys, {
        refreshInterval: REFRESH_INTERVAL_MINE_RECENT_TICKETS,
        ...config
    });
}
